// extracted by mini-css-extract-plugin
export default {"left":"style_left__vsdyH"};